<template>
<div>
    <b-card>
        <alert
            :variant="alert.variant"            
            dismissible
            :mensagens="alert.mensagens"
            :value="alert.exibir"
            @input="alertDismissed">
        </alert>
        <b-row > 
            <b-col >
                <b-form-group label="Tipo de pesquisa" label-size="sm"  label-class="font-weight-bold">
                    <b-form-radio-group
                        v-model="params.tipoPesquisa"
                        :options="tipoPesquisa"
                        name="tipo_pesquisa"
                        stacked
                    ></b-form-radio-group>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group label="Forma de pesquisa" label-size="sm"  label-class="font-weight-bold">
                    <b-form-radio-group
                        v-model="params.formaPesquisa"
                        :options="formaPesquisa"
                        name="forma_pesquisa"
                        stacked
                        @input="limparCampos"
                    ></b-form-radio-group>
                </b-form-group>
            </b-col>
            <b-col >
                <b-form-group label="Onde pesquisar" label-size="sm"  label-class="font-weight-bold">
                    <b-form-radio-group
                        v-model="params.ondePesquisar"
                        :options="ondePesquisar"
                        name="onde_pesquisar"
                        :disabled="params.formaPesquisa == $constantes.pesquisa.formaPesquisa.EDICOES"
                        stacked
                    ></b-form-radio-group>
                </b-form-group>
            </b-col>     
        </b-row>

        <b-row>
            <b-col>
                <b-form-group label="Data Início" label-size="sm"  label-class="font-weight-bold">
                    <b-form-input 
                        v-model="params.dataInicio"
                        id="inicio" 
                        type="date"
                        :max="params.dataFim" 
                        @blur="blurDataInicio"
                    ></b-form-input>
                </b-form-group>
            </b-col>
       
            <b-col>
                <b-form-group label="Data Fim" label-size="sm"  label-class="font-weight-bold">
                    <b-form-input 
                        v-model="params.dataFim"
                        id="fim"
                        type="date"
                        :min="params.dataInicio"
                        :max="dataAtual"
                        @blur="blurDataFim">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>   

        <b-row>
            <b-col> 
                <b-form-group label="Edição" label-size="sm"  label-class="font-weight-bold">
                    <b-form-input 
                        v-model="params.numeroEdicao"  
                        id="edicao" 
                        placeholder="Informe o número da edição que deseja pesquisar">
                    </b-form-input>
                </b-form-group>                
            </b-col>
        </b-row>

        <b-row >
            <b-col>
                <b-form-group label="Categoria" label-size="sm"  label-class="font-weight-bold">
                    <b-form-select 
                        id="categoria" 
                        v-model="params.categoriaAtoId"             
                        :options="categoriaAto.options"
                        :disabled="params.formaPesquisa == $constantes.pesquisa.formaPesquisa.EDICOES"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="null"></b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>         
        </b-row>
        <b-row >
            <b-col>
                <b-form-group label="Órgão"  label-size="sm"  label-class="font-weight-bold">
                    <autocomplete
                        :disabled="params.formaPesquisa == $constantes.pesquisa.formaPesquisa.EDICOES"
                        :function="buscarOrgaos"
                        key-text="sigla_nome_orgao"
                        key-id="id"
                        :active-first="false"
                        v-model="params.orgao"
                        :allow-any="false"
                        :min-search-size="2" 
                        @selected="selecionaOrgao"
                        size="sm"
                        ref="autocompleteorgao"
                        id="orgao"
                        placeholder="Informe a sigla ou nome do órgão que deseja pesquisar">
                    </autocomplete>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row >
            <b-col class="text-right">
                <b-button 
                    variant="secondary"
                    class="mr-2"
                    @click="fecharBuscaAvancada">
                    <i class="fa fa-times pr-1"></i> Fechar
                </b-button>
                <b-button 
                    variant="primary"
                    @click="pesquisar">
                    <i class="fa fa-search pr-1"></i> Pesquisar
                </b-button>
            </b-col>
        </b-row>
               
    </b-card>
</div>
</template>

<script>


import Alert from '../models/Alert'
import  autocomplete  from "./Autocomplete";
import moment from 'moment';

export default {

    components: {
        autocomplete,
    },

    props: {
        params: { type: Object, default: () => {} },
    },

    data(){
        return {

            tipoPesquisa: [
                { text: 'Qualquer resultado', value: this.$constantes.pesquisa.tipoPesquisa.QUALQUER_RESULTADO},
                { text: 'Resultado exato', value: this.$constantes.pesquisa.tipoPesquisa.RESULTADO_EXATO },
            ],
            formaPesquisa: [
                { text: 'Pesquisa por Atos', value: this.$constantes.pesquisa.formaPesquisa.ATOS },
                { text: 'Diário Completo', value: this.$constantes.pesquisa.formaPesquisa.EDICOES },
            ],
            ondePesquisar: [
                { text: 'Tudo', value: this.$constantes.pesquisa.ondePesquisar.TUDO},
                { text: 'No título', value: this.$constantes.pesquisa.ondePesquisar.TITULO },
                { text: 'No conteúdo', value: this.$constantes.pesquisa.ondePesquisar.CONTEUDO },
            ],  
            categoriaAto:{
                options:[]
            },
            alert: new Alert(),
            dataAtual: moment().format('YYYY-MM-DD'),
        }
    },

     methods: {

        blurDataInicio() {       
            if(this.params.dataInicio > this.params.dataFim) {
                this.params.dataInicio = this.params.dataFim;
            }
        },

        blurDataFim() {   
            if(this.params.dataFim > this.dataAtual){
                this.params.dataFim = this.dataAtual; 
            }

            if(this.params.dataFim < this.params.dataInicio) {
                this.params.dataFim = this.params.dataInicio;
            }
        },

        alertDismissed(){           
            this.alert = new Alert();
        },

        limparCampos(){
            if(this.params.formaPesquisa === this.$constantes.pesquisa.formaPesquisa.EDICOES){
                this.params.orgaoId = null;
                this.params.orgao = '';
                this.params.categoriaAtoId = null;      
                this.params.ondePesquisar = this.$constantes.pesquisa.ondePesquisar.CONTEUDO;      
            }
        },

        pesquisar(){
            this.$emit('pesquisar');              
        },

        fecharBuscaAvancada(){
            this.$emit('fechar');
        },

        buscarCategoriasAto(){  
            let params = {
                ind_ativo: true
            }  

            this.$api.categoriaAto.listar(params)
                .then(response => {    
                    this.categoriaAto.options = [];   

                    response.data.data.forEach(element => {                                                                                    
                        let option = {
                            value: element.id,
                            text: element.nome_categoria,
                            disabled: !element.ind_ativo 
                        };
                                  
                       this.categoriaAto.options.push(option);
                    });  
                    
                })
                .catch(error => {
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           `Erro ao buscar categoria. ${error.response.data.errors}`);      
                });       
        },

        buscarOrgaos(siglaNome){                 
            let parametros = {
               sigla_nome: siglaNome  
            }; 

            return this.$api.orgao.buscar(parametros)
                       .then(response => {                       
                            response.data.data.forEach(element => { 
                                element.sigla_nome_orgao =  element.sigla_orgao + ' - ' + element.nome_orgao;                                                  
                            });  
                          
                            return response;
                        });
        },

       selecionaOrgao(orgao){ 
           this.params.orgaoId = orgao.id;
           this.params.orgao =  orgao.sigla_nome_orgao;                                                             
        },

     },

    mounted(){
        this.buscarCategoriasAto();
    },
}

</script>

<style scoped>

    .msg-versoes-anteriores {       
       color: red;  
       font-size: 0.8em;   
       font-weight: lighter;    
       text-align: left;   
    }

</style>                